export default {
    state: {
        isCollapse: true,
        tabList: [
/*             {
                path: '/home',
                name: 'Home',
                label: '首页',
                icon: 'home'
            } */
            {
                path: '/manage/admin',
                name: 'Admin',
                label: '管理员管理',
                icon: 'custom'
            }
        ],
        currentMenu: null
    },
    mutations: {
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        selectMenu(state, val) {
            /* if (val.name !== 'Home') { */
            if (val.name !== 'Admin') {
                state.currentMenu = val
                const result = state.tabList.findIndex(item => item.name === val.name)
                if (result === -1) {
                    state.tabList.push(val)
                }
            } else {
                state.collapseMenu = null
            }
        },
        closeTag(state, val) {
            const result = state.tabList.findIndex(item => item.name === val.name)
            state.tabList.splice(result, 1)
        }
    }
}